module.exports = __webpack_public_path__ + "static/img/yg_btn1.82b4c16.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/home/pc/role3/control/yg_btn1.png
// module id = DdqB
// module chunks = 7